import { AppBar, Box, CircularProgress, Typography } from "../utils/mui-imports";
import { motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import BrowseLookSwiper from "./BrowseLookSwiperNewUI";
import BrowseLookSwiperInfluenersNewUI from "./BrowseLookInfluencersNewUI";
import { trackGAEvent } from '../utils/tracking';

const tabs = [
  { icon: "🍅", label: "Upcoming Events", param: "upcoming_event" },
  { icon: "🥬", label: "Community Looks", param: "user_generated" },
  { icon: "🧀", label: "Featured Influencers", param: "featured_influencer" },
];

export default function BrowsLooks({showAll=true}) {
  const [selectedTab, setSelectedTab] = useState(tabs[1]);
  const [curatedLooks, setCuratedLooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCuratedLooks = async () => {
      try {
        setLoading(true);
        setError(null);
        //`http://localhost:5000/api/look/browse-looks?browse_by=${selectedTab.param}`
        const response = await fetch(
          `/api/look/browse-looks?browse_by=${selectedTab.param}`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        console.log("browse data - ", data)
        setCuratedLooks(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCuratedLooks();
  }, [selectedTab]);

  return (
    <div
      style={{
        position: "relative",
        justifyContent: "center",
        paddingTop: "1.75rem",
      }}
    >
      <Box px={2}
      sx={{
        height:'5dvh'
      }}
      >
        <Typography variant="h4" fontWeight="bold" align="center">
          Browse Looks
        </Typography>
      </Box>
      <Box p={1.5}
      sx={{
        // height:'auto',
        maxHeight:'10dvh'
      }}
      >
        <nav
          style={{
            // position: "absolute",
            zIndex: 5,
            display: "flex",
            flexDirection: "column",
            // justifyContent: "space-between",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              alignContent: "center",
              alignItems: "center",
              width: "100%",
              gap: 1,
            }}
          >
            {tabs.map((item) => (
              <motion.div
                style={{
                  borderRadius: 8,
                  backdropFilter: "blur(5px)",
                }}
                key={item.label}
                initial={false}
                transition={{ duration: 0.2 }}
                animate={{
                  backgroundColor:
                    item !== selectedTab
                      ? "rgba(235, 235, 235, 1)"
                      : "rgb(19, 19, 19)",
                      color:
                      item !== selectedTab
                        ? "rgb(19, 19, 19)"
                        : "rgba(255, 255, 255, 1)",
                }}
                onClick={() => {
                  setSelectedTab(item);
                  trackGAEvent(item.param, {label: item.label});
                }}
              >
                <Typography
                  variant="h1"
                  fontWeight="bold"
                  fontSize="0.8rem"
                  align="center"
                  sx={{ p: 1 }}
                >
                  {`${item.label}`}
                </Typography>
                {item === selectedTab ? (
                  <motion.div
                    style={{
                      position: "absolute",
                      bottom: -2,
                      left: 0,
                      right: 0,
                      height: 2,
                      background: "var(--accent)",
                    }}
                    layoutId="underline"
                    id="underline"
                  />
                ) : null}
              </motion.div>
            ))}
          </Box>
        </nav>
      </Box>

      <Box height="auto" width="100%" sx={{ display: "flex" }}>
      <motion.div
                        key={selectedTab ? selectedTab.label : "empty"}
                        initial={{ y: 10, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: -10, opacity: 0 }}
                        transition={{ duration: 0.5 }}
                        style={{ width: "100%" }}
                    >
       
          <Box
            sx={{
              // backgroundColor: "rgb(0, 0, 0)",
              width: "100%",
            }}
          >
            {loading ? (
              <Box textAlign="center" py={8}
              sx={{
                background:'white',
                height:'75dvh',

              }}
              >

              <CircularProgress />
               
              </Box>
            ) : error ? (
              <Box textAlign="center" py={8} color="error.main"
              sx={{
                background:'white',
                height:'85dvh',

              }}
              >
                <Typography>Failed to load curated looks: {error}</Typography>
              </Box>
            ) : (
              selectedTab['param'] !== 'featured_influencer'? (
                <BrowseLookSwiper showAll={showAll} selectedTab={selectedTab} image_info={curatedLooks} />
              ):
              (
                <BrowseLookSwiperInfluenersNewUI showAll={showAll} image_info={curatedLooks} selectedTab={selectedTab}/>
              ) 
             
            )}
          </Box>
        </motion.div>
      </Box>
    </div>
  );
}